<template>
  <div class="border-t border-slate-100 pt-2 first:border-t-0 first:pt-0">
    <button
      type="button"
      class="flex w-full items-start gap-2 text-left text-sm"
      :aria-expanded="expanded"
      @click="expanded = !expanded"
    >
      <ChevronRightIcon
        class="mt-0.5 size-4 shrink-0 text-slate-500 transition-transform"
        :class="{ 'rotate-90': expanded }"
      />
      <span class="shrink-0" aria-hidden="true">{{ typeEmoji }}</span>
      <span class="min-w-0 flex-1">
        <span class="font-medium">{{ item.title }}</span>
        <span v-if="productLabels" class="ml-1 text-slate-500">[{{ productLabels }}]</span>
      </span>
    </button>
    <p v-if="expanded" class="mt-2 pl-6 text-sm text-slate-600">
      {{ item.body }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { formatChangesetProductLabels, getChangesetTypeEmoji } from '@/data/changeset-schema';
import type { RosDashboardUpdateItem } from '@/entities/ros-updates/ros-update.entity';
import { ChevronRightIcon } from '@heroicons/vue/24/outline';
import { computed, ref } from 'vue';

const props = defineProps<{
  item: RosDashboardUpdateItem;
}>();

const expanded = ref(false);
const typeEmoji = computed(() => getChangesetTypeEmoji(props.item.type));
const productLabels = computed(() => formatChangesetProductLabels(props.item.products));
</script>
